import { CalendarDays } from "lucide-react"

import { CtaShell } from "./cta-shell"
import type { CtaShellProps } from "./cta-types"

export type CalendarBookingCtaProps = CtaShellProps

export function CalendarBookingCta(props: CalendarBookingCtaProps) {
  return <CtaShell {...props} layout="card" actionType="booking" primaryCta={props.primaryCta ?? { label: "Book a time", href: "#calendar" }} decorative={props.decorative ?? <CalendarDays className="size-8" />} />
}
